export const PLACEHOLDER = "Escribe aquí el motivo de la subsanación";
export const SEND = "Enviar";